import { get, post, put } from '@api/request';

export const fetchTotalEstimates = async (
  { appraisalNoticeService },
  authenticationToken,
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/certifiedestimates`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const initializeTotals = async (
  { appraisalNoticeService },
  authenticationToken,
  payload,
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/certifiedestimates`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
};

export const fetchEstimate = async (
  { appraisalNoticeService },
  authenticationToken,
  { runID },
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/certifiedestimate/${runID}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchTotalRunByYear = async (
  { appraisalNoticeService },
  authenticationToken,
  { year },
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/certifiedestimates/totalrunbyyear/${year}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchRollCorrsByYear = async (
  { appraisalNoticeService },
  authenticationToken,
  { year },
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/certifiedestimates/rollcorectionsbyyear/${year}`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export const fetchEstimateTaxingUnits = async (
  { appraisalNoticeService },
  authenticationToken,
  { runID },
) => {
  const url = `${appraisalNoticeService}/prodigyappraisalnotices/certifiedestimate/${runID}/taxingunits`;
  const { body } = await get(authenticationToken, url);
  return body;
};

export async function fetchEstimateLayout(
  { appraisalNoticeService },
  authenticationToken,
) {
  let url = `${appraisalNoticeService}/prodigyappraisalnotices/certifiedestimate/layout`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function calcEstimateData(
  { appraisalNoticeService },
  authenticationToken,
  payload,
) {
  let url = `${appraisalNoticeService}/prodigyappraisalnotices/certifiedestimate/calculate`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function saveCalcEstimate(
  { appraisalNoticeService },
  authenticationToken,
  { runID, payload },
) {
  let url = `${appraisalNoticeService}/prodigyappraisalnotices/certifiedestimate/${runID}/calculate`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function saveTaxingUnits(
  { appraisalNoticeService },
  authenticationToken,
  { runID, payload },
) {
  let url = `${appraisalNoticeService}/prodigyappraisalnotices/certifiedestimate/${runID}/taxingunitupdate`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}
